import { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import "./OrderDetail.css";
import PaymentMethod from "../../components/paymentmethod_v2/PaymentMethod";
import CancelOrder from "../../components/cancelorder_v2/CancelOrder";
import MultiPurpose from "../../components/multipurpose_v2/MultiPurpose.js";
import CheckoutBranch from "../../components/checkoutbranch_v2/CheckoutBranch.js";
import OrderTrackingDetail from "../../components/trackingdetail_v2/OrderTrackingDetail.js";
import {
  ArrowLeft,
  AlertCircle,
  CircleAlert,
  Package,
  Truck,
  CircleCheck,
  CircleX,
  MapPin,
  Clock,
  ChevronDown,
  Tag,
  Gift,
  ArrowDownToLine,
  CreditCard,
  FileText,
  ArrowRight,
  Arrow,
} from "lucide-react";
import FallbackImg from "../../components/FallbackImg";
import { useSelector } from "react-redux";
import { hasAccess } from "../../utils/Permission";
import { ACCESS_KEYS, BACKEND_URL } from "../../constants";
import ApiService from "../../components/Api_services";

// ========== DO NOT add the below lines into const OrderDetail ==========
const BranchDistributionModal = ({
  onClose,
  branches,
  branchData,
  isPWP,
  isFOC,
  isDisplayDiscount,
}) => {
  // Holds { branch_code, items: [{code, qty}] } for the branch whose
  // "View More" was clicked, or null when the modal is closed.
  const [pwpDetailBranch, setPwpDetailBranch] = useState(null);

  return (
    <>
      <div className="shoppingcartbranch_v2">
        <div className="scb-title_v2">
          <div>Branch Distribution</div>
        </div>

        <div className="shoppingcartbranch-content_v2">
          <div className="scb-branch-header_v2">
            <div className="scb-subtitle-col1_v2">Branch</div>
            <div className="scb-subtitle-remaincol_v2">Quantity</div>
            {isFOC && <div className="scb-subtitle-remaincol_v2">F.O.C</div>}
            {isPWP && <div className="scb-subtitle-remaincol_v2">PWP</div>}
            {isDisplayDiscount && (
              <div className="scb-subtitle-remaincol_v2">Discount</div>
            )}
          </div>

          {branches && branches.length > 0 ? (
            (() => {
              const anyBranchHasMultiplePwpCodes = (branchData || []).some((d) => {
                const branchPwpItems = (branchData || []).filter(
                  (x) => x.branch_code === d.branch_code && x.type === "pwp",
                );
                return branchPwpItems.length > 1;
              });
              return branches
                .filter(
                  (branch) =>
                    branch.mainQty !== 0 ||
                    branch.pwpQty !== 0 ||
                    branch.focQty_displayDiscountQty !== 0,
                )
                .map((branch, idx) => {
                const branchPwpItems = (branchData || []).filter(
                  (d) => d.branch_code === branch.branch_code && d.type === "pwp",
                );

                return (
                  <div key={idx} className="shoppingcartbranch-main_v2">
                    <div className="scb-branchname-container_v2">
                      <div className="scb-branchname_v2">
                        {branch.branch_code || "HQ"}
                      </div>

                      {/* Main quantity */}
                      <div className="scb-productqty-container_v2">
                        <div className="scb-productqty-value_v2">
                          {branch.mainQty}
                        </div>
                      </div>

                      {/* FOC quantity */}
                      {isFOC && (
                        <div className="scb-productqty-container_v2">
                          <div className="scb-productqty-value_v2">
                            {branch.focQty_displayDiscountQty}
                          </div>
                        </div>
                      )}

                      {/* PWP quantity */}
                      {isPWP && (
                        <div
                          className="scb-productqty-container_v2"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {anyBranchHasMultiplePwpCodes && (
                            <button
                              type="button"
                              className="scb-viewmore-btn_v2"
                              onClick={(e) => {
                                e.stopPropagation();
                                setPwpDetailBranch({
                                  branch_code: branch.branch_code || "HQ",
                                  items: branchPwpItems.map((it) => ({
                                    code: it.item_code,
                                    qty: it.quantity,
                                  })),
                                });
                              }}
                            >
                              View More
                            </button>
                          )}
                          <div className="scb-productqty-value_v2">
                            {branch.pwpQty}
                          </div>
                        </div>
                      )}

                      {/* Display Discount quantity */}
                      {isDisplayDiscount && (
                        <div className="scb-productqty-container_v2">
                          <div className="scb-productqty-value_v2">
                            {branch.focQty_displayDiscountQty}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              });
            })()
          ) : (
            <div>No branch info available.</div>
          )}
        </div>
      </div>

      {pwpDetailBranch && (
        <MultiPurpose
          title={`PWP Branch Distribution - ${pwpDetailBranch.branch_code}`}
          hideNo={true}
          yesText="Close"
          onYes={() => setPwpDetailBranch(null)}
          onClose={() => setPwpDetailBranch(null)}
        >
          <div className="shoppingcartbranch-content_v2">
            <div className="scb-branch-header_v2" style={{ textAlign: "left" }}>
              <div className="scb-subtitle-col1_v2">Branch</div>
              {pwpDetailBranch.items.map((it) => (
                <div key={it.code} className="scb-subtitle-remaincol_v2">
                  {it.code}
                </div>
              ))}
            </div>

            <div className="shoppingcartbranch-main_v2">
              <div className="scb-branchname-container_v2">
                <div className="scb-branchname_v2">
                  {pwpDetailBranch.branch_code}
                </div>
                {pwpDetailBranch.items.map((it) => (
                  <div key={it.code} className="scb-productqty-container_v2">
                    <div className="scb-productqty-value_v2">{it.qty}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </MultiPurpose>
      )}
    </>
  );
};

const CartItemContainer = ({
  item,
  index,
  openBranchDistributionIdx,
  openCurrPromoMenuIdx,
  setOpenCurrPromoMenuIdx,
  setOpenBranchDistributionIdx,
  formatCurrency,
  BranchDistributionModal,
}) => {
  const displayBranches = (item.branchDistribution || []).filter(
    (branch) =>
      branch.mainQty !== 0 ||
      branch.pwpQty !== 0 ||
      branch.focQty_displayDiscountQty !== 0,
  );

  return (
    <div key={index} className="cartitem-container_v2" data-index={index}>
      <div className="badge-container_v2">
        {item.package_id > 0 && (
          <div className="package-badge_v2">
            PACKAGE: {item.package?.package_description ?? ""}
          </div>
        )}
        {item.quotation_id && (
          <div className="package-badge_v2">
            QUOTATION : {item.quotation_id}
          </div>
        )}
        {item.cs_id > 0 && <div className="package-badge_v2">SPONSOR</div>}
      </div>

      <div className="cartitem-inner_v2">
        <div className="cart-image-container_v2">
          <FallbackImg
            src={item.item_photo}
            alt={item.item_name}
            className="cartitem-image_v2"
          />
        </div>

        <div className="cartitem-details_v2">
          <div className="cartitem-top-row_v2">
            <div style={{ width: "80%" }}>
              <div className="cartitem-code_v2">{item.item_code}</div>
              <div className="cartitem-name_v2">{item.item_name}</div>
            </div>
            {item.is_bundle && (
              <>
                <div
                  className="bundle-description_v2"
                  style={{
                    marginTop: 6,
                    color: "#666",
                    fontSize: 13,
                    lineHeight: "16px",
                  }}
                >
                  Package Contents
                </div>

                <div
                  className="bundle-list_v2"
                  style={{ marginTop: 6, paddingLeft: 4 }}
                >
                  {Array.isArray(item.bundle_items) &&
                    item.bundle_items.map((bi, biIdx) => (
                      <div
                        key={biIdx}
                        className="bundle-row_v2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "4px 4px",
                          borderBottom:
                            biIdx === item.bundle_items.length - 1
                              ? "none"
                              : "1px solid #f1f1f1",
                        }}
                      >
                        <div
                          style={{
                            width: 18,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "0 0 18px",
                          }}
                        >
                          {biIdx === 0 ? (
                            <ArrowRight size={16} />
                          ) : (
                            <div style={{ width: 14 }} />
                          )}
                        </div>

                        <div
                          style={{
                            flex: 1,
                            fontSize: 11,
                            color: "#333",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {bi.item_code} - {bi.item_name}
                        </div>
                      </div>
                    ))}
                </div>
              </>
            )}
          </div>

          {(() => {
            // Find the selected tag/promotion for this item
            const selectedTag = item.filteredPromoItems.find(
              (promo) => promo.promo_name,
            );

            const originalPrice =
              Number(item.price) + Number(item.discount || 0);

            // Show discounted price and qty for Item Discount and Buy X Discount Y
            if (
              selectedTag &&
              (selectedTag.promo_name === "Item Discount" ||
                /^Buy\s*\d+\s*Discount\s*\d+%$/i.test(selectedTag.promo_name))
            ) {
              return (
                <>
                  <div className="cartitem-bot-row_v2">
                    <div className="cartitem-price_v2">
                      <div className="cartitem-price-title_v2">Unit Price</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span className="normalprice_v2">
                          RM {item.price ? formatCurrency(item.price) : "0.00"}
                        </span>
                        <span className="deductedprice_v2">
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    </div>

                    <div className="cartitem-qty_v2">
                      <div className="cartitem-qty-title_v2">Quantity</div>
                      <div className="cartitem-qty-value_v2">
                        {item.totalQuantity}
                      </div>
                    </div>

                    <div className="cartitem-total_v2">
                      <div className="cartitem-total-title_v2">Subtotal</div>
                      <div className="cartitem-RM-container_v2">
                        <div className="cartitem-RM_v2">RM</div>
                        {formatCurrency(
                          (item.price ? Number(item.price) : 0) *
                            item.totalQuantity,
                        )}
                      </div>
                    </div>
                  </div>
                </>
              );
            }

            // Show discounted price and qty only for Buy X Free Y
            else if (
              selectedTag &&
              /^Buy\s*\d+\s*Free\s*\d$/i.test(selectedTag.promo_name)
            ) {
              // Extract X and Y from the promo_name, e.g. "Buy 10 Free 3"
              const match = selectedTag.promo_name.match(
                /^Buy\s*(\d+)\s*Free\s*(\d+)$/i,
              );
              let focQty = 0;
              if (match) {
                focQty = Number(match[2]);
              }

              return (
                <>
                  <div className="cartitem-bot-row_v2">
                    <div className="cartitem-price_v2">
                      <div className="cartitem-price-title_v2">Unit Price</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span className="normalprice_v2">
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    </div>

                    <div className="cartitem-qty_v2">
                      <div className="cartitem-qty-title_v2">Quantity</div>
                      <div className="cartitem-qty-value-container_v2">
                        <div className="cartitem-qty-value_v2">
                          {item.totalQuantity}
                        </div>
                        <div className="cartitem-qty-foc_v2">
                          + {focQty} free
                        </div>
                      </div>
                    </div>

                    <div className="cartitem-total_v2">
                      <div className="cartitem-total-title_v2">Subtotal</div>
                      <div className="cartitem-RM-container_v2">
                        <div className="cartitem-RM_v2">RM</div>
                        {formatCurrency(
                          (item.price ? Number(item.price) : 0) *
                            item.totalQuantity,
                        )}
                      </div>
                      {focQty > 0 && (
                        <div className="cartitem-RM-foc_v2">
                          Save RM{" "}
                          {item.price
                            ? formatCurrency(item.price * focQty)
                            : "0.00"}{" "}
                          on {focQty} free {focQty > 1 ? "units" : "unit"}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              );
            }

            // Otherwise, show only the current price and qty
            return (
              <>
                <div className="cartitem-bot-row_v2">
                  <div className="cartitem-price_v2">
                    <div className="cartitem-price-title_v2">Unit Price</div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span className="normalprice_v2">
                        RM {item.price ? formatCurrency(item.price) : "0.00"}
                      </span>
                      {originalPrice > Number(item.price) && (
                        <span className="deductedprice_v2">
                          RM {formatCurrency(originalPrice)}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="cartitem-qty_v2">
                    <div className="cartitem-qty-title_v2">Quantity</div>
                    <div className="cartitem-qty-value_v2">
                      {item.totalQuantity}
                    </div>
                  </div>

                  <div className="cartitem-total_v2">
                    <div className="cartitem-total-title_v2">Subtotal</div>
                    <div className="cartitem-RM-container_v2">
                      <div className="cartitem-RM_v2">RM</div>
                      {formatCurrency(
                        (item.price ? Number(item.price) : 0) *
                          item.totalQuantity,
                      )}
                    </div>
                  </div>
                </div>
              </>
            );
          })()}
        </div>
      </div>

      <div className="branch-toggle-container_v2">
        <div
          className="branch-toggle_v2"
          onClick={(e) => {
            e.stopPropagation();
            setOpenBranchDistributionIdx((prev) =>
              prev === index ? null : index,
            );
            setOpenCurrPromoMenuIdx(null);
          }}
        >
          <div className="branch-toggle-left_v2">
            <Package size={16} color={"#1e5bc6"} />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2px",
                fontSize: "14px",
              }}
            >
              Stock Allocation
              <div className="branch-toggle-count_v2">
                {displayBranches.length || 0}{" "}
                {displayBranches.length === 1 ? "branch" : "branches"} allocated
              </div>
            </div>
          </div>
          <ChevronDown
            size={16}
            className={openBranchDistributionIdx === index ? "rotate_v2" : ""}
          />
        </div>

        {item.availablePromotions.length > 0 && (
          <div
            className="currpromo-dropdown_v2"
            onClick={(e) => {
              e.stopPropagation();
              setOpenCurrPromoMenuIdx((prev) =>
                prev === index ? null : index,
              );
              setOpenBranchDistributionIdx(null);
            }}
          >
            <div className="currpromo-dropdown-left_v2">
              <Tag size={16} color={"#00a63e"} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  fontSize: "14px",
                }}
              >
                Applied Promotions
                <div className="currpromo-dropdown-count_v2">
                  {item.availablePromotions.length || 0}{" "}
                  {item.availablePromotions.length === 1
                    ? "promotion"
                    : "promotions"}{" "}
                  applied
                </div>
              </div>
            </div>
            <div className="currpromotion-arrowdown_v2">
              <ChevronDown
                size={16}
                className={openCurrPromoMenuIdx === index ? "rotate_v2" : ""}
              />
            </div>
          </div>
        )}
      </div>

      {/* CSS in OrderDetailBranch.css */}
      {openBranchDistributionIdx === index && (
        <BranchDistributionModal
          onClose={() => setOpenBranchDistributionIdx(null)}
          branches={item.branchDistribution}
          branchData={item.branch_data}
          isPWP={item.isPWP}
          isFOC={item.isFOC}
          isDisplayDiscount={item.isDisplayDiscount}
        />
      )}

      {/* Show All Promotion */}
      {openCurrPromoMenuIdx === index &&
        item.availablePromotions.length > 0 && (
          <>
            <div className="currpromo-menu_v2">
              <div className="currpromo-title_v2">Applied Promotions</div>
              {item.filteredPromoItems
                .filter((tag) => tag.promo_name !== "Free Gift")
                .map((tag, tagIdx) => {
                  const isQuantityOfferDiscount =
                    /^Buy\s*\d+\s*Discount\s*\d+%$/i.test(tag.promo_name);
                  const isQuantityOfferFree = /^Buy\s*\d+\s*Free\s*\d+$/i.test(
                    tag.promo_name,
                  );
                  const isQuantityOffer =
                    isQuantityOfferDiscount || isQuantityOfferFree;

                  return (
                    <div key={tagIdx} className="currpromo-branch_v2">
                      <div className="currpromo-left_v2">
                        <FallbackImg src={tag.item_photo} alt={tag.item_name} />
                      </div>
                      <div className="currpromo-center_v2">
                        <div className="promoitem-name_v2">{tag.item_code}</div>
                        <div className="promoitem-qty_v2">
                          Quantity : {tag.quantity}
                        </div>
                        <div className="promoitem-price_v2">
                          {parseFloat(tag.price) === 0
                            ? "RM 0.00"
                            : `RM ${formatCurrency(tag.price)}`}
                          {tag.discount > 0 && (
                            <span
                              style={{
                                textDecoration: "line-through",
                                color: "#a1a1a1",
                                marginLeft: 8,
                                fontSize: "12px",
                              }}
                            >
                              RM{" "}
                              {formatCurrency(
                                Number(tag.price) + Number(tag.discount),
                              )}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="currpromo-right_v2">
                        <div
                          className={`promoitem-tag_v2 ${isQuantityOffer ? "purple" : "orange"}`}
                        >
                          {isQuantityOffer ||
                          tag.promo_name.includes("PWP") ||
                          tag.promo_name.includes("Discount") ||
                          tag.promo_name.includes("Display Discount") ? (
                            <Tag size={14} />
                          ) : null}
                          {tag.promo_name === "Discount"
                            ? "Item Discount"
                            : tag.promo_name}
                        </div>
                      </div>
                    </div>
                  );
                })}

              {/* Free Gift */}
              {item.freeGiftItems.length > 0 &&
                item.freeGiftItems.map((fg, fgIdx) => (
                  <div key={fgIdx} className="currpromo-branch_v2">
                    <div className="currpromo-left_v2">
                      <FallbackImg src={fg.item_photo} alt={fg.item_name} />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{fg.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity : {fg.quantity}
                      </div>
                      <div className="promoitem-price_v2">
                        <span>RM 0.00</span>
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 green">
                        <Gift size={14} />
                        Free Gift
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </>
        )}
    </div>
  );
};
// =======================================================================

const OrderDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPaymentMethod, setShowPaymentMethod] = useState(false);
  const [showCancelOrder, setShowCancelOrder] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [activeType, setActiveType] = useState("cancelled");
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const [selectedBranch, setSelectedBranch] = useState(null);
  const seconds = Math.floor((timeRemaining / 1000) % 60);
  const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
  const hours = Math.floor(timeRemaining / (1000 * 60 * 60));

  const params = new URLSearchParams(location.search);
  const canPay = params.has("canpay");
  const [notice, setNotice] = useState({ show: false, message: "" });

  // New states for the redesigned item display
  const [selectedPromotions, setSelectedPromotions] = useState({});
  const [showItemDropdown, setShowItemDropdown] = useState(true);
  const [showBranchDropdown, setShowBranchDropdown] = useState(false);
  const [showDocumentDropdown, setShowDocumentDropdown] = useState(false);
  const [showTransDropdown, setShowTransDropdown] = useState(false);
  const [showCancelDropdown, setShowCancelDropdown] = useState(false);
  const [openCurrPromoMenuIdx, setOpenCurrPromoMenuIdx] = useState(null);
  const [openBranchDistributionIdx, setOpenBranchDistributionIdx] =
    useState(null);
  const [showReceiptIframe, setShowReceiptIframe] = useState(false);
  const [showAttachment, setShowAttachment] = useState(false);
  const [showSoFileIframe, setShowSoFileIframe] = useState(false);
  const [docIframeUrl, setDocIframeUrl] = useState(null);
  const [showReceivedNotif, setShowReceivedNotif] = useState(false);
  const [showTrackingDetail, setShowTrackingDetail] = useState(false);

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const parseExpiryDate = (dateStr) => {
    if (!dateStr) return null;

    // console.log("Parsing expiry date:", dateStr);
    try {
      if (dateStr.includes("a.m.") || dateStr.includes("p.m.")) {
        const parts = dateStr.split(" ");
        if (parts.length >= 3) {
          const datePart = parts[0];
          const timePart = parts[1];
          const ampm = parts[2];

          const [year, month, day] = datePart.split("-").map(Number);
          let hour = parseInt(timePart) || 0;

          if (ampm.toLowerCase().includes("p.m.") && hour < 12) {
            hour += 12;
          } else if (ampm.toLowerCase().includes("a.m.") && hour === 12) {
            hour = 0;
          }

          const parsedDate = new Date(year, month - 1, day, hour, 0, 0);
          // console.log("Parsed date:", parsedDate);
          return parsedDate;
        }
      }

      const date = new Date(dateStr);
      if (!isNaN(date.getTime())) {
        // console.log("Standard parsed date:", date);
        return date;
      }

      console.error("Failed to parse date:", dateStr);
      return null;
    } catch (error) {
      console.error("Error parsing date:", error, dateStr);
      return null;
    }
  };

  const sub_role = useSelector((state) => state.auth.sub_role) || [];
  const is_subuser =
    useSelector((state) => state.auth.user?.is_subuser) || false;
  const canPayOrCancel =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_ORDER);

  // Fetch order details when component mounts
  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        setLoading(true);
        const response = await ApiService.getOrderDetails(id);

        if (response.status === 200) {
          setOrderData(response.data);

          if (response.data.order_details?.expiry_date) {
            const expiryDate = parseExpiryDate(
              response.data.order_details.expiry_date,
            );
            if (expiryDate) {
              const now = new Date();
              // console.log("Current time:", now);
              const remaining = expiryDate - now;
              // console.log("Calculated remaining time (ms):", remaining);
              setTimeRemaining(Math.max(0, remaining));
            } else {
              console.warn("Failed to parse expiry date, setting default");
              setTimeRemaining(8 * 60 * 60 * 1000);
            }
          }

          const statusMap = {
            New: "topay",
            Processing: "toship",
            "Ready To Ship": "toship",
            Shipping: "toreceive",
            Received: "toreceive",
            Cancelled: "cancelled",
          };

          setActiveType(
            statusMap[response.data.order_details.status_label] || "topay",
          );
        } else {
          setError(response.message || "Failed to load order details");
        }
      } catch (err) {
        setError("An error occurred while fetching order details");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchOrderDetails();
    }
  }, [id]);

  // useEffect(() => {
  //   if (timeRemaining <= 0) {
  //     if (activeType === "topay" && orderData?.order_details?.order_no) {
  //       handleAutoCancelOrder();
  //     }
  //     return;
  //   }

  //   // console.log("Setting countdown timer, remaining ms:", timeRemaining);
  //   const timer = setInterval(() => {
  //     setTimeRemaining((prevTime) => {
  //       const newTime = prevTime - 1000;
  //       if (newTime <= 0) {
  //         clearInterval(timer);
  //         if (activeType === "topay" && orderData?.order_details?.order_no) {
  //           handleAutoCancelOrder();
  //         }
  //         return 0;
  //       }
  //       return newTime;
  //     });
  //   }, 1000);

  //   return () => clearInterval(timer);
  // }, [timeRemaining, activeType, orderData]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleString("en-MY", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getPaymentDate = (orderData) => {
    if (!orderData?.payment_detail) return "";

    const { payment_method, transaction_detail } = orderData.payment_detail;

    // Extract date based on payment method
    if (payment_method === "FPX" || payment_method === "B2B FPX") {
      return transaction_detail?.Date || "";
    } else if (payment_method === "CHEQUE" || payment_method === "IBG") {
      return transaction_detail?.bank_in_date || "";
    } else {
      // For other payment methods or if specific field is not available
      return orderData.payment_detail.payment_date || "";
    }
  };

  const handleAutoCancelOrder = async () => {
    try {
      if (!orderData?.order_details?.order_no) return;

      if (showCancelOrder) return;

      // console.log("Auto-cancelling order:", orderData.order_details.order_no);

      const response = await ApiService.cancelOrders(
        orderData.order_details.order_no,
      );

      if (response && response.status) {
        setNotice({
          show: true,
          message: "This order has expired and been automatically cancelled.",
        });
        navigate("/allorder?type=cancelled");
      } else {
        console.error("Failed to auto-cancel order:", response);
      }
    } catch (error) {
      console.error("Error auto-cancelling order:", error);
    }
  };

  const handleCancelSuccess = () => {
    // Show success message
    setNotice({
      show: true,
      message: "Order has been cancelled successfully.",
    });

    // Navigate to the cash/topay tab
    navigate("/allorder?type=topay");
  };

  // Utility function to calculate total quantity and total amount for a branch of an item
  function calculateBranchTotals(branch, itemCode) {
    let totalQuantity = 0;
    let totalAmount = 0;

    // Sum up all items in this branch that match the itemCode
    branch.items.forEach((item) => {
      if (item.item_code === itemCode) {
        totalQuantity += Number(item.quantity) || 0;
        totalAmount += Number(item.total) || 0;
      }
    });

    return {
      totalQuantity,
      totalAmount,
    };
  }

  const branchOptionsRaw = orderData?.item_detail.map((branch) => {
    // Calculate total quantity and amount for all items in this branch
    let totalQuantity = 0;
    let totalAmount = 0;

    branch.items.forEach((item) => {
      totalQuantity += Number(item.quantity) || 0;
      totalAmount += Number(item.total) || 0;
    });

    return {
      value: branch.branch_code,
      label: (
        <div className="scb-branchname-container_v2">
          <div className="scb-branchname_v2">{branch.branch_code}</div>
          <div className="scb-productqty-container_v2">
            <div className="orderdetail-table-value_v2 first">
              {Array.isArray(branch.items)
                ? branch.items
                    .reduce((sum, item) => sum + parseFloat(item.cbm || 0), 0)
                    .toFixed(4)
                : 0}
            </div>
          </div>
          <div className="scb-productqty-container_v2">
            <div className="orderdetail-table-value_v2">
              <div className="branch-custom-dropdown-RM_v2">RM</div>{" "}
              {branch.shipping_fee
                ? formatCurrency(branch.shipping_fee)
                : "0.00"}
            </div>
          </div>
          <div className="scb-productqty-container_v2">
            <div className="orderdetail-table-value_v2 last">
              <div className="branch-custom-dropdown-RM_v2">RM</div>{" "}
              {totalAmount ? formatCurrency(totalAmount) : "0.00"}
            </div>
          </div>
        </div>
      ),
    };
  });

  const selectedBranchObj = orderData?.item_detail.find(
    (b) => b.branch_code === selectedBranch,
  );

  const branchCodes =
    orderData?.item_detail?.map((branch) => branch.branch_code) || [];

  let branchCodeDisplay = "-";
  if (Array.isArray(branchCodes)) {
    if (branchCodes.length === 1) {
      branchCodeDisplay = "1 branch";
    } else if (branchCodes.length > 1) {
      branchCodeDisplay = `${branchCodes.length} branches`;
    }
  }

  const handleBranchSelect = (option) => {
    setSelectedBranch(option.value);
  };

  const otherDocuments = (orderData?.other_documents || []).filter(
    (doc) => doc.show_do_id !== null && doc.show_do_id !== "",
  );

  const openDoReport = (do_id) => {
    if (!do_id) return;
    setDocIframeUrl(
      `${BACKEND_URL}pdf_report/sales_centre_do_report/${btoa(do_id)}`,
    );
  };

  const openInvoiceReport = (invoice_id) => {
    if (!invoice_id) return;
    setDocIframeUrl(
      `${BACKEND_URL}pdf_report/invoice_report/${btoa(invoice_id)}`,
    );
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/allorder?page=1&type=all"); // fallback route
    }
  };

  return (
    <div className="orderdetail_v2">
      <div className="orderdetail-content_v2">
        {notice.show && (
          <MultiPurpose
            title="Notice"
            message={notice.message}
            yesText="OK"
            showYesLink={false}
            hideNo={true}
            onYes={() => setNotice({ show: false, message: "" })}
            onNo={() => setNotice({ show: false, message: "" })}
            onClose={() => setNotice({ show: false, message: "" })}
          />
        )}

        <div className="orderdetail-back-margin_v2">
          <div className="orderdetail-back-container_v2">
            <button className="orderdetail-back_v2" onClick={handleBack}>
              <ArrowLeft size={20} />
              Back to My Orders
            </button>
          </div>
        </div>

        <div className="orderdetail-main_v2">
          {canPayOrCancel ? (
            <>
              {loading ? (
                <div className="loading_v2">Loading order details...</div>
              ) : error ? (
                <div className="error_v2">{error}</div>
              ) : orderData ? (
                <>
                  <div className="orderinfo_v2">
                    <div className="orderinfo-header_v2">
                      <div>
                        <div className="orderinfo-header-subtitle_v2">
                          Order Number
                        </div>
                        <div className="orderinfo-header-value_v2">
                          {orderData?.order_details?.order_no || ""}
                        </div>
                      </div>
                      <div
                        className={`orderinfo-header-tag_v2 ${orderData.order_details.status_label ? ` ${orderData.order_details.status_label.toLowerCase().replace(/\s/g, "")}` : ""}`}
                      >
                        {orderData?.order_details?.status_label === "New" ? (
                          <CircleAlert size={20} />
                        ) : orderData?.order_details?.status_label ===
                          "Processing" ? (
                          <Package size={20} />
                        ) : orderData?.order_details?.status_label ===
                          "Shipping" ? (
                          <Truck size={20} />
                        ) : orderData?.order_details?.status_label ===
                          "Received" ? (
                          <CircleCheck size={20} />
                        ) : orderData?.order_details?.status_label ===
                          "Cancelled" ? (
                          <CircleX size={20} />
                        ) : null}
                        {orderData?.order_details?.status_label === "Received"
                          ? "Completed"
                          : orderData?.order_details?.status_label || ""}
                      </div>
                    </div>

                    <div className="orderinfo-content_v2">
                      <div className="orderinfo-content-top_v2">
                        <div className="orderinfo-content-item_v2">
                          <div className="orderinfo-content-item-subtitle_v2">
                            Order Date
                          </div>
                          <div className="orderinfo-content-item-value_v2">
                            {formatDate(
                              orderData?.order_details?.created_date,
                            ) || ""}
                          </div>
                        </div>
                        <div className="orderinfo-content-item_v2">
                          <div className="orderinfo-content-item-subtitle_v2">
                            Total Quantity
                          </div>
                          <div className="orderinfo-content-item-value_v2">
                            {orderData?.order_summary?.total_qty || ""} items
                          </div>
                        </div>
                        <div className="orderinfo-content-item_v2">
                          <div className="orderinfo-content-item-subtitle_v2">
                            Delivery To
                          </div>
                          <div className="orderinfo-content-item-value_v2">
                            <MapPin
                              size={16}
                              className="orderinfo-content-icon_v2"
                            />
                            {branchCodeDisplay}
                          </div>
                        </div>
                        <div className="orderinfo-content-item_v2">
                          <div className="orderinfo-content-item-subtitle_v2">
                            Total Amount
                          </div>
                          <div className="orderinfo-content-item-value_v2 last">
                            RM{" "}
                            {orderData?.order_summary?.total_price
                              ? formatCurrency(
                                  orderData?.order_summary?.total_price,
                                )
                              : "0.00"}
                          </div>
                        </div>
                      </div>

                      {activeType === "topay" &&
                        orderData?.order_details?.status_label === "To Pay" && (
                          <div className="orderclose_v2">
                            <div className="orderclose-caption_v2">
                              <Clock size={20} color={"#f54a00"} /> Order will
                              close in
                            </div>
                            <div className="orderclose-cdtimer_v2">
                              <div className="orderclose-time_v2">
                                {hours.toString().padStart(2, "0")}
                              </div>
                              <div>:</div>
                              <div className="orderclose-time_v2">
                                {minutes.toString().padStart(2, "0")}
                              </div>
                              <div>:</div>
                              <div className="orderclose-time_v2">
                                {seconds.toString().padStart(2, "0")}
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Branch dropdown */}
                  <div className="orderdetail-dropdown_v2">
                    <div
                      className="orderdetail-dropdown-selected_v2"
                      onClick={() => setShowItemDropdown((prev) => !prev)}
                    >
                      Order Items
                      <ChevronDown
                        className={showItemDropdown ? "rotate_v2" : ""}
                      />
                    </div>

                    {/* Collapsible body */}
                    <div
                      className="orderdetail-dropdown-body_v2"
                      style={{
                        display: showItemDropdown ? "block" : "none",
                      }}
                    >
                      {orderData.grouped_item_detail.map((item, index) => {
                        return (
                          <CartItemContainer
                            key={index}
                            item={item}
                            index={index}
                            openBranchDistributionIdx={
                              openBranchDistributionIdx
                            }
                            openCurrPromoMenuIdx={openCurrPromoMenuIdx}
                            setOpenCurrPromoMenuIdx={setOpenCurrPromoMenuIdx}
                            formatCurrency={formatCurrency}
                            BranchDistributionModal={BranchDistributionModal}
                            setOpenBranchDistributionIdx={
                              setOpenBranchDistributionIdx
                            }
                          />
                        );
                      })}
                    </div>
                  </div>

                  {/* Branch dropdown */}
                  <div className="orderdetail-dropdown_v2">
                    <div
                      className="orderdetail-dropdown-selected_v2"
                      onClick={() => setShowBranchDropdown((prev) => !prev)}
                    >
                      Branch Allocation
                      <ChevronDown
                        className={showBranchDropdown ? "rotate_v2" : ""}
                      />
                    </div>

                    {/* Collapsible body */}
                    <div
                      className="orderdetail-dropdown-body_v2"
                      style={{
                        display: showBranchDropdown ? "block" : "none",
                      }}
                    >
                      <div className="shoppingcartbranch-content_v2">
                        <div className="scb-branch-header_v2">
                          <div className="scb-subtitle-col1_v2">Branch</div>
                          <div
                            className="scb-subtitle-remaincol_v2"
                            style={{ justifyContent: "center" }}
                          >
                            CBM
                          </div>
                          <div className="scb-subtitle-remaincol_v2">
                            Delivery Charge
                          </div>
                          <div className="scb-subtitle-remaincol_v2">
                            Subtotal
                          </div>
                        </div>

                        {branchOptionsRaw.map((option, idx) => (
                          <div
                            key={option.value}
                            className="shoppingcartbranch-main_v2"
                            onClick={() => handleBranchSelect(option)}
                          >
                            {option.label}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Documents dropdown */}
                  <div className="orderdetail-dropdown_v2">
                    <div
                      className="orderdetail-dropdown-selected_v2"
                      onClick={() => setShowDocumentDropdown((prev) => !prev)}
                    >
                      Other Documents
                      <ChevronDown
                        className={showDocumentDropdown ? "rotate_v2" : ""}
                      />
                    </div>

                    {/* Collapsible body */}
                    <div
                      className="orderdetail-dropdown-body_v2"
                      style={{
                        display: showDocumentDropdown ? "block" : "none",
                      }}
                    >
                      <div className="shoppingcartbranch-content_v2">
                        <div className="scb-branch-header_v2">
                          <div className="scb-subtitle-col1_v2">Branch</div>
                          <div className="scb-subtitle-remaincol_v2">DO</div>
                          <div className="scb-subtitle-remaincol_v2">
                            Invoice
                          </div>
                        </div>

                        {otherDocuments.length > 0 ? (
                          otherDocuments.map((doc, idx) => (
                            <div
                              key={idx}
                              className="shoppingcartbranch-main_v2"
                            >
                              <div className="scb-branchname-container_v2">
                                <div className="scb-branchname_v2">
                                  {doc.branch || "-"}
                                </div>

                                <div className="scb-productqty-container_v2">
                                  <div
                                    className="orderdetail-downloadreceipt_v2"
                                    style={{
                                      color: "#1e5bc6",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => openDoReport(doc.do_id)}
                                  >
                                    <FileText size={14} />
                                    {doc.show_do_id}
                                  </div>
                                </div>

                                <div className="scb-productqty-container_v2">
                                  {doc.invoice_id ? (
                                    <div
                                      className="orderdetail-downloadreceipt_v2"
                                      style={{
                                        color: "#1e5bc6",
                                        textDecoration: "underline",
                                      }}
                                      onClick={() =>
                                        openInvoiceReport(doc.invoice_id)
                                      }
                                    >
                                      <FileText size={14} />
                                      {doc.invoice_id}
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div
                            className="shoppingcartbranch-main_v2"
                            style={{
                              padding: "16px",
                              textAlign: "center",
                              color: "#888",
                            }}
                          >
                            No documents available.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {(activeType === "toship" || activeType === "toreceive") &&
                    orderData.payment_detail && (
                      <div className="orderdetail-dropdown_v2">
                        {/* Branch dropdown */}
                        <div
                          className="orderdetail-dropdown-selected_v2"
                          onClick={() => setShowTransDropdown((prev) => !prev)}
                        >
                          Transaction Details
                          <ChevronDown
                            className={showTransDropdown ? "rotate_v2" : ""}
                          />
                        </div>

                        {/* Collapsible body */}
                        <div
                          className="orderdetail-dropdown-body_v2"
                          style={{
                            display: showTransDropdown ? "block" : "none",
                          }}
                        >
                          <div className="orderdetail-trans_v2">
                            <div className="orderdetail-trans-icon_v2">
                              <CircleCheck size={24} />
                            </div>

                            <div className="orderdetail-transdetail_v2">
                              <div className="orderdetail-trans-title-container_v2">
                                <div>Payment Successful</div>
                                {orderData?.payment_detail?.receipt && (
                                  <button
                                    className="orderdetail-downloadreceipt_v2"
                                    onClick={() => setShowReceiptIframe(true)}
                                    type="button"
                                  >
                                    <FileText size={16} />
                                    Download Receipt
                                  </button>
                                )}
                              </div>

                              <div className="orderdetail-trans-item-container_v2">
                                <div className="orderdetail-trans-itemlist_v2">
                                  <div className="orderdetail-trans-item_v2">
                                    <div>Payment Method</div>
                                    <div className="orderdetail-trans-item-value_v2">
                                      {orderData?.payment_detail
                                        ?.payment_method || "-"}
                                    </div>
                                  </div>
                                  <div className="orderdetail-trans-item_v2">
                                    <div>Amount Paid</div>
                                    <div className="orderdetail-trans-item-value_v2">
                                      RM{" "}
                                      {orderData?.payment_detail?.payment_amount
                                        ? formatCurrency(
                                            orderData?.payment_detail
                                              ?.payment_amount,
                                          )
                                        : "0.00"}
                                    </div>
                                  </div>
                                  <div className="orderdetail-trans-item_v2">
                                    <div>Payer Bank</div>
                                    <div className="orderdetail-trans-item-value_v2">
                                      {orderData?.payment_detail
                                        ?.transaction_detail?.bank_name ??
                                        orderData?.payment_detail
                                          ?.transaction_detail
                                          ?.Buyer_Bank_Name ??
                                        "-"}
                                    </div>
                                  </div>
                                </div>

                                <div className="orderdetail-trans-itemlist_v2">
                                  <div className="orderdetail-trans-item_v2">
                                    <div>Transaction Date</div>
                                    <div className="orderdetail-trans-item-value_v2">
                                      {formatDate(
                                        orderData?.payment_detail
                                          ?.transaction_detail?.bank_in_date ??
                                          orderData?.payment_detail
                                            ?.transaction_detail?.Date,
                                      ) || "-"}
                                    </div>
                                  </div>
                                  <div className="orderdetail-trans-item_v2">
                                    <div>Transaction ID</div>
                                    <div className="orderdetail-trans-item-value_v2">
                                      {orderData?.payment_detail
                                        ?.transaction_detail
                                        ?.FPX_Transaction_ID || "-"}
                                    </div>
                                  </div>
                                  <div className="orderdetail-trans-item_v2">
                                    <div>Supporting Document</div>

                                    {(orderData?.payment_detail
                                      ?.transaction_detail?.photo_url && (
                                      <div
                                        className="orderdetail-trans-item-value_v2"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowAttachment(true)}
                                      >
                                        <ArrowDownToLine size={16} /> Attachment
                                      </div>
                                    )) ||
                                      "-"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                  {activeType === "cancelled" && (
                    <div className="orderdetail-dropdown_v2">
                      {/* Branch dropdown */}
                      <div
                        className="orderdetail-dropdown-selected_v2"
                        onClick={() => setShowCancelDropdown((prev) => !prev)}
                      >
                        Cancellation Details
                        <ChevronDown
                          className={showCancelDropdown ? "rotate_v2" : ""}
                        />
                      </div>

                      {/* Collapsible body */}
                      <div
                        className="orderdetail-dropdown-body_v2"
                        style={{
                          display: showCancelDropdown ? "block" : "none",
                        }}
                      >
                        <div className="orderdetail-cancel_v2">
                          <div className="orderdetail-cancel-icon_v2">
                            <CircleX size={24} />
                          </div>

                          <div className="orderdetail-canceldetail_v2">
                            <div className="orderdetail-cancel-title-container_v2">
                              <div>Order Cancelled</div>
                            </div>

                            <div className="orderdetail-cancel-item-container_v2">
                              <div
                                className="orderdetail-cancel-item_v2"
                                style={{ flex: "1" }}
                              >
                                <div>Cancelled By</div>
                                <div className="orderdetail-cancel-item-value_v2">
                                  {orderData?.order_details?.cancel_by ||
                                    "System Automation"}
                                </div>
                              </div>
                              <div
                                className="orderdetail-cancel-item_v2"
                                style={{ flex: "1" }}
                              >
                                <div>Cancellation Date</div>
                                <div className="orderdetail-cancel-item-value_v2">
                                  {formatDate(
                                    orderData?.order_details?.update_date || "",
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="orderdetail-cancel-item_v2">
                              <div>Reason</div>
                              <div className="orderdetail-cancel-item-value_v2">
                                {orderData?.order_details?.cancel_reason ||
                                  "Automatically cancelled due to payment timeout"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="orderdetail-sub_v2">
                    <div
                      className="orderdetail-card_v2"
                      style={{ width: "68%" }}
                    >
                      <div className="orderdetail-cardtitle_v2">
                        Price Breakdown
                      </div>

                      <div className="orderdetail-carddetail_v2">
                        <div className="orderdetail-card-item_v2">
                          <div className="orderdetail-card-item-subtitle_v2">
                            Subtotal
                          </div>
                          <div className="orderdetail-card-item-value_v2">
                            <div className="orderdetail-RM_v2">RM</div>
                            {orderData?.order_summary
                              ? formatCurrency(
                                  orderData?.order_summary?.sub_price +
                                    orderData?.order_summary?.discount -
                                    (orderData?.order_summary?.pwp_amount || 0),
                                )
                              : "0.00"}
                          </div>
                        </div>
                        {orderData?.order_summary?.pwp_amount > 0 && (
                          <div className="orderdetail-card-item_v2">
                            <div className="orderdetail-card-item-subtitle_v2">
                              PWP Purchase
                            </div>
                            <div className="orderdetail-card-item-value_v2">
                              <div className="orderdetail-RM_v2">RM</div>
                              {formatCurrency(
                                orderData.order_summary.pwp_amount,
                              )}
                            </div>
                          </div>
                        )}
                        <div className="orderdetail-card-item_v2">
                          <div className="orderdetail-card-item-subtitle_v2">
                            Discount
                          </div>
                          <div className="orderdetail-card-item-value_v2 discount">
                            <div className="orderdetail-RM_v2">-RM</div>
                            {orderData?.order_summary?.discount
                              ? formatCurrency(
                                  orderData?.order_summary?.discount,
                                )
                              : "0.00"}
                          </div>
                        </div>
                        <div className="orderdetail-card-item_v2">
                          <div className="orderdetail-card-item-subtitle_v2">
                            Delivery Fees
                          </div>
                          <div className="orderdetail-card-item-value_v2">
                            <div className="orderdetail-RM_v2">RM</div>
                            {orderData?.order_summary?.shipping_fee
                              ? formatCurrency(
                                  orderData?.order_summary?.shipping_fee,
                                )
                              : "0.00"}
                          </div>
                        </div>
                        <div className="orderdetail-card-item_v2 last">
                          <div className="orderdetail-card-item-subtitle_v2">
                            Total Amount
                          </div>
                          <div className="orderdetail-card-item-value_v2">
                            <div className="orderdetail-RM_v2">RM</div>
                            {orderData?.order_summary?.total_price
                              ? formatCurrency(
                                  orderData?.order_summary?.total_price,
                                )
                              : "0.00"}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="orderdetail-card_v2"
                      style={{ width: "32%" }}
                    >
                      <div className="orderdetail-cardtitle_v2">Actions</div>

                      <div className="orderdetail-carddetail_v2">
                        <div className="orderdetail-buttons_v2">
                          {activeType === "topay" && (
                            <>
                              {canPay && (
                                <button
                                  className="orderdetail-ok-button_v2"
                                  onClick={() => {
                                    if (!canPayOrCancel) return;
                                    if (timeRemaining <= 0) {
                                      setNotice({
                                        show: true,
                                        message:
                                          "This order has expired and cannot be paid.",
                                      });
                                      return;
                                    }
                                    setShowPaymentMethod(true);
                                  }}
                                  disabled={!canPayOrCancel}
                                  style={{
                                    opacity: canPayOrCancel ? 1 : 0.5,
                                    cursor: canPayOrCancel
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                  title={canPayOrCancel ? "" : "No permission"}
                                >
                                  <CreditCard size={16} />
                                  PAY NOW
                                </button>
                              )}

                              {orderData?.order_details?.status_label !==
                                "To Pay - Processing" && (
                                <button
                                  className="orderdetail-no-button_v2"
                                  onClick={() => {
                                    if (!canPayOrCancel) return;
                                    setShowCancelOrder(true);
                                  }}
                                  disabled={!canPayOrCancel}
                                  style={{
                                    opacity: canPayOrCancel ? 1 : 0.5,
                                    cursor: canPayOrCancel
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                  title={canPayOrCancel ? "" : "No permission"}
                                >
                                  CANCEL ORDER
                                </button>
                              )}
                            </>
                          )}

                          {(activeType === "toship" ||
                            activeType === "toreceive") && (
                            <button
                              className="orderdetail-ok-button_v2"
                              onClick={() => setShowTrackingDetail(true)}
                            >
                              <Truck size={16} />
                              TRACK ORDER
                            </button>
                          )}

                          {orderData?.order_details?.status_label ===
                            "Shipping" && (
                            <button
                              className="orderdetail-receive-button_v2"
                              onClick={(e) => {
                                if (!canPayOrCancel) return;
                                setShowReceivedNotif(true);
                              }}
                              style={{
                                opacity: canPayOrCancel ? 1 : 0.5,
                                cursor: canPayOrCancel
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              title={canPayOrCancel ? "" : "No permission"}
                            >
                              <CircleCheck size={16} />
                              RECEIVED
                            </button>
                          )}

                          {orderData?.order_details?.so_file_url && (
                            <button
                              className="orderdetail-download-button_v2"
                              onClick={() => setShowSoFileIframe(true)}
                            >
                              <FileText size={16} />
                              DOWNLOAD ORDER PDF
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="error_v2">No order details found</div>
              )}
            </>
          ) : (
            <div
              style={{
                minHeight: "60vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span style={{ color: "#b71c1c", fontWeight: 600 }}>
                You do not have permission to view My Order.
              </span>
            </div>
          )}
        </div>
      </div>
      {selectedBranch && selectedBranchObj && (
        <CheckoutBranch
          branch={selectedBranchObj}
          onClose={() => setSelectedBranch(null)}
        />
      )}
      {showPaymentMethod && (
        <PaymentMethod
          onClose={() => setShowPaymentMethod(false)}
          onSelect={(paymentMethod) => {
            if (orderData.order_details.order_no) {
              let paymentType = "";
              if (paymentMethod === "Online Banking") {
                paymentType = "online_banking";
              } else if (paymentMethod === "FPX") {
                paymentType = "fpx";
              }

              navigate(
                `/uploadcheque?orders=${orderData.order_details.order_no}&type=${paymentType}`,
              );
            }
          }}
          orderNum={1}
          orderId={orderData.order_details.order_no}
          totalAmount={orderData.order_summary.total_price}
        />
      )}
      {showCancelOrder && (
        <CancelOrder
          orderId={orderData.order_details.order_no}
          onClose={() => setShowCancelOrder(false)}
          onSuccess={handleCancelSuccess}
          orderNo={1}
        />
      )}
      {showTrackingDetail && (
        <OrderTrackingDetail
          order_no={orderData.order_details.order_no}
          onClose={() => setShowTrackingDetail(false)}
        />
      )}
      {showReceivedNotif && (
        <MultiPurpose
          title="Confirm Order Receipt"
          useHTML={true}
          message={`Are you sure you want to confirm receipt of this order?<br /><span style="color: #1e5bc6; font-weight: 600;">Order No: ${orderData.order_details.order_no}</span>`}
          yesText="Confirm Receipt"
          noText="Cancel"
          onNo={() => setShowReceivedNotif(false)}
          onYes={async () => {
            if (orderData.order_details.order_no) {
              await ApiService.confirmReceive(orderData.order_details.order_no);
              setShowReceivedNotif(false);
              navigate("/allorder?type=toreceive");
            }
          }}
          onClose={() => setShowReceivedNotif(false)}
          variant="success"
          className="received"
        />
      )}
      {showReceiptIframe && (
        <div
          className="image-preview-modal"
          onClick={() => setShowReceiptIframe(false)}
        >
          <div
            className="image-preview-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="image-preview-close"
              onClick={() => setShowReceiptIframe(false)}
            >
              ×
            </button>
            <iframe
              src={orderData.payment_detail.receipt}
              title="Receipt Preview"
              style={{
                width: "90vw",
                height: "90vh",
                border: "none",
              }}
            />
          </div>
        </div>
      )}
      {showAttachment && (
        <div
          className="image-preview-modal"
          onClick={() => setShowAttachment(false)}
        >
          <div
            className="image-preview-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="image-preview-close"
              onClick={() => setShowAttachment(false)}
            >
              ×
            </button>
            <FallbackImg
              src={orderData.payment_detail.transaction_detail.photo_url}
              alt="Transaction Attachment Preview"
              style={{
                width: "90vw",
                height: "90vh",
                border: "none",
              }}
            />
          </div>
        </div>
      )}
      {showSoFileIframe && (
        <div
          className="image-preview-modal"
          onClick={() => setShowSoFileIframe(false)}
        >
          <div
            className="image-preview-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="image-preview-close"
              onClick={() => setShowSoFileIframe(false)}
            >
              ×
            </button>
            <iframe
              src={orderData.order_details.so_file_url}
              title="SO Preview"
              style={{
                width: "90vw",
                height: "90vh",
                border: "none",
              }}
            />
          </div>
        </div>
      )}
      {docIframeUrl && (
        <div
          className="image-preview-modal"
          onClick={() => setDocIframeUrl(null)}
        >
          <div
            className="image-preview-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="image-preview-close"
              onClick={() => setDocIframeUrl(null)}
            >
              ×
            </button>
            <iframe
              src={docIframeUrl}
              title="Document Preview"
              style={{
                width: "90vw",
                height: "90vh",
                border: "none",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderDetail;
